
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/context/AuthContext";

export const useActiveStoreId = () => {
  const { user } = useAuth();
  
  console.log('🔑 useActiveStoreId called with user:', user?.id);
  
  return useQuery({
    queryKey: ['active-store-id', user?.id],
    queryFn: async () => {
      if (!user?.id) {
        console.warn('❌ No user ID found');
        return null;
      }
      
      console.log('🔍 Fetching active store for user:', user.id);
      
      const { data, error } = await supabase
        .from('nuvemshop_tokens')
        .select('store_id')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .single();

      if (error) {
        console.error('❌ Error fetching active store ID:', error);
        return null;
      }

      console.log('✅ Active store found:', data?.store_id);
      return data?.store_id || null;
    },
    enabled: !!user?.id,
    staleTime: 10 * 60 * 1000, // 10 minutes - evita re-fetch constante
    refetchOnWindowFocus: false, // CRÍTICO: evita re-fetch no Alt+Tab
    refetchOnMount: false, // Evita re-fetch ao montar componente
    retry: 3
  });
};
